import { Component, OnDestroy, OnInit } from '@angular/core';
// import { CommonGridService } from 'src/app/shared/services/common-grid.service';
import { QaReportService } from '../services/qa-report.service';

@Component({
  selector: 'app-qa-report-grid',
  templateUrl: './qa-report-grid.component.html',
  styleUrls: ['./qa-report-grid.component.scss']
})
export class QaReportGridComponent implements OnInit, OnDestroy {
  gridApi: any;
  // public gridApiUrl:string = "/diary_user_responses"
  // public type:string = "day"
  // constructor(public cgService:CommonGridService) { }
  constructor(public qaService:QaReportService) { }
  ngOnDestroy(): void {
    this.gridApi = null;
  }

  ngOnInit(): void {

  }


  onGridReady(params): void {
    if(!this.gridApi) {
        this.gridApi = params.api;
        // this.gridApi.setSuppressRowDrag(false);
    }
    this.gridApi = params.api;
  }

  sizeToFit(): void {
    if(this.gridApi) {
      this.gridApi.sizeColumnsToFit();
    }
  }
  onModelUpdated(params): void {
    if(!this.gridApi) {
        this.gridApi = params.api;
    }
    this.sizeToFit();
  }
  onFirstDataRendered(): void {
    this.sizeToFit();
  }
}
